<template>
  <section class="permission-section custom-margin-top">
    <!-- NOTE M1 Permission -->
    <div class="mt-2">
      <atom-switch
        title="Full Access"
        v-model="isFullAccessPermission"
        @change="togglePermissionFullAccess"
      ></atom-switch>
    </div>
    <div v-if="wpmList.length" class="relative-header">
      <span
        v-if="isWpmFullPermission"
        class="toggle-text wpm-toggle-position"
        @click="togglePermission('wpm', false)"
        >Disable All</span
      >
      <span
        v-else
        class="toggle-text wpm-toggle-position"
        @click="togglePermission('wpm', true)"
        >Enable All</span
      >
      <b-card-actions
        title="WEB PORTAL"
        class="relative-header"
        action-collapse
      >
        <div class="permission-grid">
          <div
            v-for="(page, index) in wpmList"
            :key="index"
            class="permission-card"
            :class="{
              'card-active': page.permissions.some(
                (permission) => permission.enable
              ),
            }"
          >
            <div
              class="card--header d-flex align-items-center mb-1"
              :class="{
                'text-primary': page.permissions.some(
                  (permission) => permission.enable
                ),
              }"
            >
              <div
                class="page-icon"
                :class="{
                  'icon-active': page.permissions.some(
                    (permission) => permission.enable
                  ),
                }"
              >
                <feather-icon :icon="page.icon" size="14" />
              </div>
              <span class="custom-text-bold custom-text-14 pl-1 mb-0">
                {{ page.page }}
              </span>
            </div>
            <div
              v-for="(permission, index) in page.permissions"
              :key="index"
              class="card--content d-flex align-items-center justify-content-between"
            >
              <span>{{ permission.title }}</span>
              <atom-switch v-model="permission.enable" />
            </div>
          </div>
        </div>
      </b-card-actions>
    </div>

    <!-- NOTE M2 Permission -->
    <div v-if="smsList.length" class="relative-header">
      <span
        v-if="isSmsFullPermission"
        class="toggle-text sms-toggle-position"
        @click="togglePermission('sms', false)"
        >Disable All</span
      >
      <span
        v-else
        class="toggle-text sms-toggle-position"
        @click="togglePermission('sms', true)"
        >Enable All</span
      >
      <b-card-actions title="SERVER MANAGER" action-collapse>
        <div class="permission-grid">
          <div
            v-for="(page, index) in smsList"
            :key="index"
            class="permission-card"
            :class="{
              'card-active': page.permissions.some(
                (permission) => permission.enable
              ),
            }"
          >
            <div
              class="card--header d-flex align-items-center mb-1"
              :class="{
                'text-primary': page.permissions.some(
                  (permission) => permission.enable
                ),
              }"
            >
              <div
                class="page-icon"
                :class="{
                  'icon-active': page.permissions.some(
                    (permission) => permission.enable
                  ),
                }"
              >
                <feather-icon :icon="page.icon" size="14" />
              </div>
              <span class="custom-text-bold custom-text-14 pl-1 mb-0">
                {{ page.page }}
              </span>
            </div>
            <div
              v-for="(permission, index) in page.permissions"
              :key="index"
              class="card--content d-flex align-items-center justify-content-between"
            >
              <span>{{ permission.title }}</span>
              <atom-switch v-model="permission.enable" />
            </div>
          </div>
        </div>
      </b-card-actions>
    </div>

    <!-- NOTE M3 Permission -->
    <div v-if="bmmList.length" class="relative-header">
      <span
        v-if="isBmmFullPermission"
        class="toggle-text bmm-toggle-position"
        @click="togglePermission('bmm', false)"
        >Disable All</span
      >
      <span
        v-else
        class="toggle-text bmm-toggle-position"
        @click="togglePermission('bmm', true)"
        >Enable All</span
      >
      <b-card-actions title="BACKUP MANAGER" action-collapse>
        <div class="permission-grid">
          <div
            v-for="(page, index) in bmmList"
            :key="index"
            class="permission-card"
            :class="{
              'card-active': page.permissions.some(
                (permission) => permission.enable
              ),
            }"
          >
            <div
              class="card--header d-flex align-items-center mb-1"
              :class="{
                'text-primary': page.permissions.some(
                  (permission) => permission.enable
                ),
              }"
            >
              <div
                class="page-icon"
                :class="{
                  'icon-active': page.permissions.some(
                    (permission) => permission.enable
                  ),
                }"
              >
                <feather-icon :icon="page.icon" size="14" />
              </div>
              <span class="custom-text-bold custom-text-14 pl-1 mb-0">
                {{ page.page }}
              </span>
            </div>
            <div
              v-for="(permission, index) in page.permissions"
              :key="index"
              class="card--content d-flex align-items-center justify-content-between"
            >
              <span>{{ permission.title }}</span>
              <atom-switch v-model="permission.enable" />
            </div>
          </div>
        </div>
      </b-card-actions>
    </div>

    <!-- NOTE M4 Permission -->
    <div v-if="ncmList.length" class="relative-header">
      <span
        v-if="isNcmFullPermission"
        class="toggle-text ncm-toggle-position"
        @click="togglePermission('ncm', false)"
        >Disable All</span
      >
      <span
        v-else
        class="toggle-text ncm-toggle-position"
        @click="togglePermission('ncm', true)"
        >Enable All</span
      >
      <b-card-actions title="NETWORK CONFIGURATION" action-collapse>
        <div class="permission-grid">
          <div
            v-for="(page, index) in ncmList"
            :key="index"
            class="permission-card"
            :class="{
              'card-active': page.permissions.some(
                (permission) => permission.enable
              ),
            }"
          >
            <div
              class="card--header d-flex align-items-center mb-1"
              :class="{
                'text-primary': page.permissions.some(
                  (permission) => permission.enable
                ),
              }"
            >
              <div
                class="page-icon"
                :class="{
                  'icon-active': page.permissions.some(
                    (permission) => permission.enable
                  ),
                }"
              >
                <feather-icon :icon="page.icon" size="14" />
              </div>
              <span class="custom-text-bold custom-text-14 pl-1 mb-0">
                {{ page.page }}
              </span>
            </div>
            <div
              v-for="(permission, index) in page.permissions"
              :key="index"
              class="card--content d-flex align-items-center justify-content-between"
            >
              <span>{{ permission.title }}</span>
              <atom-switch v-model="permission.enable" />
            </div>
          </div>
        </div>
      </b-card-actions>
    </div>
  </section>
</template>

<script>
import AtomSwitch from "@/components/atoms/AtomSwitch.vue"
import BCardActions from "@/@core/components/b-card-actions/BCardActions.vue"
export default {
  components: { AtomSwitch, BCardActions },
  name: "MoleculePermissionCard",
  props: {
    value: {
      type: Array,
      required: true,
    },
  },
  computed: {
    permissionList: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit("input", value)
      },
    },
    wpmList() {
      return this.permissionList.filter((page) => page.module === "wpm")
    },
    smsList() {
      return this.permissionList.filter((page) => page.module === "sms")
    },
    bmmList() {
      return this.permissionList.filter((page) => page.module === "bmm")
    },
    ncmList() {
      return this.permissionList.filter((page) => page.module === "ncm")
    },
    isWpmFullPermission() {
      return this.wpmList?.every((page) =>
        page.permissions.every((permission) => permission.enable)
      )
    },
    isSmsFullPermission() {
      return this.smsList?.every((page) =>
        page.permissions.every((permission) => permission.enable)
      )
    },
    isBmmFullPermission() {
      return this.bmmList?.every((page) =>
        page.permissions.every((permission) => permission.enable)
      )
    },
    isNcmFullPermission() {
      return this.ncmList?.every((page) =>
        page.permissions.every((permission) => permission.enable)
      )
    },
    isFullAccessPermission: {
      get() {
        return (
          this.isWpmFullPermission &&
          this.isSmsFullPermission &&
          this.isBmmFullPermission &&
          this.isNcmFullPermission
        )
      },
      set(value) {},
    },
  },

  methods: {
    togglePermission(module, value) {
      switch (module) {
        case "wpm":
          this.wpmList.forEach((page) =>
            page.permissions.forEach(
              (permission) => (permission.enable = value)
            )
          )
          break
        case "sms":
          this.smsList.forEach((page) =>
            page.permissions.forEach(
              (permission) => (permission.enable = value)
            )
          )
          break
        case "bmm":
          this.bmmList.forEach((page) =>
            page.permissions.forEach(
              (permission) => (permission.enable = value)
            )
          )
          break
        case "ncm":
          this.ncmList.forEach((page) =>
            page.permissions.forEach(
              (permission) => (permission.enable = value)
            )
          )
          break
      }
    },
    togglePermissionFullAccess() {
      if (this.isFullAccessPermission) {
        this.wpmList.forEach((page) =>
          page.permissions.forEach((permission) => (permission.enable = false))
        )
        this.smsList.forEach((page) =>
          page.permissions.forEach((permission) => (permission.enable = false))
        )
        this.bmmList.forEach((page) =>
          page.permissions.forEach((permission) => (permission.enable = false))
        )
        this.ncmList.forEach((page) =>
          page.permissions.forEach((permission) => (permission.enable = false))
        )
      } else {
        this.wpmList.forEach((page) =>
          page.permissions.forEach((permission) => (permission.enable = true))
        )
        this.smsList.forEach((page) =>
          page.permissions.forEach((permission) => (permission.enable = true))
        )
        this.bmmList.forEach((page) =>
          page.permissions.forEach((permission) => (permission.enable = true))
        )
        this.ncmList.forEach((page) =>
          page.permissions.forEach((permission) => (permission.enable = true))
        )
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.permission-section ::v-deep .card {
  margin-bottom: 0;
}

::v-deep .card-header .card-title {
  font-size: 14px;
  font-weight: 500;
  color: #b9b9c3;
  text-transform: uppercase;
}

.permission-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, 100%);
  grid-gap: 2rem;
  justify-content: space-between;
}

.permission-card {
  padding: 1.5rem;
  border: 1px solid #b9b9c3;
  border-radius: 6px;
}

.card-active {
  border: 1px solid #7367f0;
}

.card--content {
  margin-top: 10px;
  margin-bottom: 10px;
}

.page-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  width: fit-content;
  padding: 9px;
  border: 1px solid #ffffff;
  border-radius: 6px;
  background-color: #f6f7f8;
}

.icon-active {
  background-color: #eeecfd;
}

.custom-margin-top {
  margin-top: 0.25rem;
}

.custom-text-module {
  font-weight: 500;
  text-transform: uppercase;
}

.custom-text-bold {
  font-weight: 600;
}

.custom-text-14 {
  font-size: 14;
}

.relative-header {
  position: relative;
}

.toggle-text {
  position: absolute;
  z-index: 1;

  font-weight: 600;
  font-size: 12px;
  color: #7367f0;
  &:hover {
    text-decoration: underline;
    cursor: pointer;
  }
}

.wpm-toggle-position {
  top: 23px;
  left: 140px;
}

.sms-toggle-position {
  top: 23px;
  left: 185px;
}

.bmm-toggle-position {
  top: 23px;
  left: 185px;
}

.ncm-toggle-position {
  top: 23px;
  left: 250px;
}

// Small devices (landscape phones, 576px and up)
@media screen and (min-width: 576px) {
}

// Medium devices (tablets, 768px and up)
@media screen and (min-width: 768px) {
  .permission-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, 45%);
    grid-gap: 2rem 0.5rem;
    justify-content: space-between;
  }
}

// Large devices (desktops, 992px and up)
@media screen and (min-width: 992px) {
}

// X-Large devices (large desktops, 1200px and up)
@media screen and (min-width: 1200px) {
  .permission-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, 280px);
    grid-gap: 2rem;
    justify-content: space-between;
  }
}
</style>
